import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  /*
   * GEOFLEET
   */
  {
    path: "/",
    component: () => import(/* webpackChunkName: "geofleet" */ "./../views/geofleet/GeoFleet.vue"),
    children: [
      {
        path: "/",
        name: "geofleet.index",
        component: { render: h => h(false) }
      },
      {
        path: "vehicle/:id",
        name: "geofleet.vehicle_details",
        component: () => import(/* webpackChunkName: "geofleet" */ "@/views/geofleet/components/VehiclePanel")
      },
      {
        path: "vehicle/:id/driver_details/:driver_id/plafond",
        name: "geofleet.driver_plafond",
        component: () => import(/* webpackChunkName: "geofleet" */ "@/views/geofleet/components/PlafondPage")
      },
      {
        path: "vehicle/:id/plan",
        name: "geofleet.vehicle_plan",
        component: () => import(/* webpackChunkName: "geofleet" */ "@/views/geofleet/components/RoutePage")
      },
      {
        path: "vehicle/:id/route",
        name: "geofleet.vehicle_analyze",
        component: () => import(/* webpackChunkName: "geofleet" */ "@/views/geofleet/components/AnalyzePage")
      },
      {
        path: "poi-management",
        name: "geofleet.poi_management",
        component: () => import(/* webpackChunkName: "geofleet" */ "@/views/geofleet/components/PoiManagementPage")
      },
      {
        path: "settings",
        name: "geofleet.settings",
        component: () => import(/* webpackChunkName: "geofleet" */ "@/views/geofleet/components/SettingsPage")
      },
      {
        path: "location",
        name: "geofleet.location",
        component: () => import(/* webpackChunkName: "geofleet" */ "@/views/geofleet/components/LocationPage")
      }
    ]
  },

  /*
   * GEOFLEET SHARE LINK
   */
  {
    path: "/view-shared-link/:token",
    name: "viewvehicle.index",
    component: () => import(/* webpackChunkName: "sharedlinks" */ "./../views/viewsharedlink/viewSharedLink.vue"),
  },

  /*
   * PLANNER PORTAL
   */
  {
    path: "/planner/",
    name: "planner.index",
    component: () => import(/* webpackChunkName: "planner" */ "./../views/plannerPortal/plannerPortal.vue"),
  },

  /**
   * Errors/Service pages
   */
  {
    path: "/errors/",
    name: "errors.index",
    component: () => import(/* webpackChunkName: "errors" */ "./../views/errors/ErrorLayout.vue"),
    children: [
      {
        name: "error-403",
        path: "permissions",
        component: () => import(/* webpackChunkName: "errors" */ "./../views/errors/ErrorPermissions.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
